import React, { useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate } from 'react-router-dom';
import '../../styles/ForgotPassword.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        setLoading(true);

        try {
            await axios.post('/api/v1/auth/reset-password-request', { email });
            setMessage('Link do resetowania hasła został wysłany na Twój e-mail.');
        } catch (err) {
            setError('Nie udało się wysłać prośby o resetowanie hasła. Spróbuj ponownie.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-box">
                <h1>Resetuj hasło</h1>
                <p>Podaj swój adres e-mail, aby otrzymać link do resetowania hasła.</p>
                <form className="forgot-password-form" onSubmit={handleSubmit}>
                    <input
                        type="email"
                        name="email"
                        placeholder="Wpisz swój e-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    {message && <p className="forgot-password-success">{message}</p>}
                    {error && <p className="forgot-password-error">{error}</p>}
                    <button type="submit" className="submit-button" disabled={loading}>
                        {loading ? 'Wysyłanie...' : 'Wyślij link resetujący'}
                    </button>
                    <button type="button" className="back-button" onClick={() => navigate('/')}>
                        Powrót do logowania
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;